import {mainQuery} from '@github-ui/react-core/future/main-query'

import {commitsAppBuilder} from '../config/app-builder'
import type {CommitPayload} from '../types/commit-types'

export const commitPathRoute = commitsAppBuilder.createQueryRouteConfig('commitPathRoute', {
  path: '/:owner/:repo/commit/:oid/:path/*',
  queries: [
    mainQuery<CommitPayload>({
      queryDeps: ({pathname, searchParams}) => ({pathname, searchParams: searchParams.toString()}),
    }),
  ],
})
